// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function ReceiptXBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M27 4.5H5A2.5 2.5 0 0 0 2.5 7v19a1.5 1.5 0 0 0 2.171 1.341L8 25.677l3.329 1.664a1.5 1.5 0 0 0 1.342 0L16 25.677l3.329 1.664a1.5 1.5 0 0 0 1.342 0L24 25.677l3.329 1.664A1.498 1.498 0 0 0 29.5 26V7A2.5 2.5 0 0 0 27 4.5Zm-.5 19.073-1.829-.914a1.5 1.5 0 0 0-1.342 0L20 24.323l-3.329-1.664a1.5 1.5 0 0 0-1.342 0L12 24.323l-3.329-1.664a1.5 1.5 0 0 0-1.342 0l-1.829.914V7.5h21v16.073Zm-14.561-6.634L13.875 15l-1.936-1.939A1.5 1.5 0 0 1 13 10.496c.399 0 .781.159 1.063.44L16 12.875l1.939-1.94a1.503 1.503 0 0 1 2.125 2.125L18.125 15l1.94 1.939a1.503 1.503 0 0 1-2.125 2.125L16 17.125l-1.939 1.94a1.502 1.502 0 1 1-2.125-2.125l.003-.001Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
